<template>
  <div class="business">
    <Bg ref='bgs'></Bg>
    <div class="title">
      <div class="title-logo"></div>
      <div class="title-right">
        <div class="menu">
          <nx-nav />
        </div>
        <!-- 网站名和网址都不能重复，一项重复则反馈到前台 -->
        <div class="title-user">
          <user-info v-if="!ifLogin"></user-info>
          <login-user v-if="ifLogin" class="tc" :setLo="true"></login-user>
        </div>
      </div>
    </div>
    <div class="info-wrap" >
      <div class="info-search"></div>
      <div class="info-top">
        <div class="info-dropdown" v-if="ifLogin">
          <span  v-for="(item,index) in statusTab" :key="index" @click="statusTabs(index)">{{ item }}</span>
          <el-input
            v-model="searchValue"
            @keyup.enter.native="searchSite"
            clearable
            @clear="clearSearch"
            size="mini"
            placeholder="网站搜索"
            ref="inputB"
            class="inputA"
          ></el-input>
          <div class="switchSite">
            <span class="nxsite insite" @click="nxsite()">逆行监控网站</span>
            <span class="mesite" @click="mesite()">我的监控网站</span>
          </div>
        </div>
        <div class="info-status" v-if="ifLogin">
          <div class="info-status-list">
            <div class="info-all chartNum">{{ siteSuccess+siteWarning+siteError }}</div>
            <div class="chartStatusBox" ref="chartAll"></div>
            <div @click="statusTab(0)" class="activeTab" style="color:#21a2f5;">全部</div>
          </div>
          <div class="info-status-list">
            <div class="info-error chartNum">{{siteError}}</div>
            <div class="chartStatusBox" ref="chartError"></div>
            <div @click="statusTab(1)" class="activeTab">严重</div>
          </div>
          <div class="info-status-list">
            <div class="info-warning chartNum">{{siteWarning}}</div>
            <div class="chartStatusBox" ref="chartWarning"></div>
            <div @click="statusTab(2)" class="activeTab">预警</div>
          </div>
          <div class="info-status-list">
            <div class="info-success chartNum">{{siteSuccess}}</div>
            <div class="chartStatusBox" ref="chartSuccess"></div>
            <div @click="statusTab(3)" class="activeTab">正常</div>
          </div>
        </div>
      </div>
      <div class="editPro" v-show="actPro" :class="{editData:actPro}">
        <div class="editBox">
          <div class="editContent">
            <el-dialog :visible.sync="actPro" :before-close="resetAddSite" title="新增监控网站">
              <el-form ref="addSite" :model="addSite" :rules="addRules" label-position="left">
                <el-form-item label="网站名称" prop="name" style="margin-bottom:10px">
                  <el-input v-model="addSite.name" />
                </el-form-item>
                <el-form-item label="网站地址" prop="address" style="margin-bottom:10px">
                  <el-input v-model="addSite.address" />
                </el-form-item>
                <el-form-item>
                  <div class="editBtn">
                    <span><el-button  type="primary" @click="addMesite()">新增</el-button></span>
                    <span><el-button @click="resetAddSite">取消</el-button></span>
                    </div>
                </el-form-item>
              </el-form>
            </el-dialog>
            
          </div>
        </div>
      </div>
      <div class="web-table">
        <div class="tableBox" v-for="(item,index) in resInfo" :key="index">
          <div
            class="tableItem"
            :class="item.status === '严重'?'yanzhong':item.status==='预警'?'yujing':'zhengchang'"
          >
            <div class="tableName">{{ item.name }}</div>
            <div class="line"></div>
            <div class="siteBox">
              <div class="siteOne">
                <div class="address">
                  <span>网站地址：</span>
                  {{ item.address }}
                </div>
                <div class="speed">
                  <span>响应速度：</span>
                  {{ item.resTime }}
                  <span class="second">秒</span>
                </div>
                <div class="pv" v-if="!adds">
                  <span>PV：{{ item.pv?item.pv:'---' }}</span>
                  <span>UV：{{ item.uv?item.uv:'---' }}</span>
                </div>
                <div class="cpu" v-if="!adds">
                  <span class="lineLeft">CPU使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.cpuUsage}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.cpuUsage }}</span>
                </div>
                <div class="cpu" v-if="!adds">
                  <span class="lineLeft">内存使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.memUsage}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.memUsage }}</span>
                </div>
                <div class='cpu' v-if='adds'>
                  <span>用户：</span>
                  <span>{{$store.state.nickName}}</span>
                </div>
              </div>
              <div class="siteTwo">
                <div class="address">
                  <span>网站地址：</span>
                  {{ item.address2 }}
                </div>
                <div class="speed">
                  <span>响应速度：</span>
                  {{ item.resTime2 }}
                  <span class="second">秒</span>
                </div>
                <div class="pv">
                  <span>PV：{{ item.pv2?item.pv2:'---' }}</span>
                  <span>UV：{{ item.uv2?item.uv2:'---' }}</span>
                </div>
                <div class="cpu">
                  <span class="lineLeft">CPU使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.cpuUsage2}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.cpuUsage2 }}</span>
                </div>
                <div class="cpu">
                  <span class="lineLeft">内存使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.memUsage2}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.memUsage2 }}</span>
                </div>
              </div>
            </div>
            <div class="tableBtn" v-if="!adds">
              <div class="siteBtnTwo"  @click="siteTwoShow(index,$event)" v-if="item.address2">站点二</div>
              <div class="siteBtnOne"  @click="siteOneShow(index,$event)" v-if="item.address">站点一</div>
            </div>
            <div class="tableLike">
              <img :src="getLike(item)" @click="likes(index, $event)" alt />
            </div>
          </div>

        </div>
        <div class="tableBox" v-show="ifLogin && adds" v-if="Math.ceil(webShow.length / 12) == pageNum && adds || webShow.length == 0">
          <div class="tableItem zhengchang">
            <div class="tableName">点击添加你想关注的网站</div>
            <div class="line"></div>
            <dir class="addImg" @click="addSiteShow()">
              <img src="../../assets/addSite.png" alt="" srcset="">
            </dir>
          </div>
        </div>
      </div>
      <div class="loading" v-if="loadingShow === true">
        <div class="loadingImg"></div>
      </div>
      <div class="info-page" v-show="value">
        <el-pagination
          background
          layout="prev,pager,next"
          :page-size="pageCount"
          :total="webShow.length"
          @current-change="handleCurrentChange"
          :current-page="pageNum" 
        ></el-pagination>
      </div>
      <div class="noData" v-show="dataLength">
        <img :src="noData" alt="">
        <div class="noText">无数据</div>
      </div>
    </div>
    <tabBottom></tabBottom>
  </div>
</template>

<script>

import { setUserInfo } from '@/js/utils'
import axios from "axios";
import NxNav from "../NxNav";
import tabBottom from "../tabBottom";
import UserInfo from "../user";
import loginUser from "../user2";
import Bg from "../bg.vue";
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/pie"); // 饼图
const likeImg = require("@/assets/like.png");
const unlikeImg = require("@/assets/unlike.png");
export default {
  components: {
    NxNav,
    UserInfo,
    Bg,
    tabBottom,
    loginUser
  },
  data() {
    return {
      a: require("@/assets/unlike.png"),
      description: "监控客户网站响应速度",
      showTime: "",
      webRes: [],
      webTemp: [],
      webShow: [],
      showStatus: "全部",
      showColor: {
        全部: "#409eff",
        正常: "#67C23A",
        预警: "#E6A23C",
        严重: "#F56C6C"
      },
      resInfo: [],
      pageTotal: null,
      pageNum: 1,
      pageCount: 12,
      siteSuccess: 0,
      siteWarning: 0,
      siteError: 0,
      searchValue: "",
      searchMode: false,
      wxAppData: "",
      ifstaff: "",
      servers: [],
      statusTabs: ["全部", "严重", "预警", "正常"],
      value: false,
      siteChange:'',
      noneData:require("../../assets/noneData.png"),
      noData:require("../../assets/noData.png"),
      dataLength:false,
      bg:[],
      loadingShow: true,
      adds:false,
      actPro:false,
      addSite:{
        name:null,
        address:null,
      },
      addRules: {
        name: { required: true },
        address: { required: true },
      },
    };
  },
  mounted() {
    var me = this;
    this.loadingShow = true;
    
    setTimeout(() => {
      console.log('me.ifLogin :>> ', me.ifLogin);
      if (localStorage.getItem('Lo')==3 || me.ifLogin) {
      clearInterval(me.siteChange);
      me.getShowTime();
      me.queryUsageRate();
      me.staffnames();
      setInterval(me.getShowTime, 1000);
      me.siteChange = setInterval(me.pageAutoChange, 10 * 1000);
      me.getSite();
      me.loadingShow = false;
    }
    else{
      me.value = false;
      localStorage.setItem('Lo', 2);
      me.loadingShow = false;
    } 
    if (!me.ifLogin) {
      me.loadingShow = false;
    }
    me.$refs.bgs.clearAll()
    if(localStorage.getItem('Lo')==2){
      me.$refs.bgs.all()
    }
    else{
      me.$refs.bgs.clearAll()
    }
    },2000)
    
  },
  sockets: {
    getUserInfo:function(data){
      setUserInfo.call(this, data)
      this.getSite();
      this.loadingShow = false;
    },
    nameStaff: function(data) {
      console.log('nameStaff:', data);
      if (this.ifLogin && data.likeWeb != "") {
        this.$store.state.likeweb = data[0].likeweb.split(",").map(Number)
      }
    },
    receiveSite: function(data) {
      var me = this;
      me.webTemp = data;
      me.webRes = JSON.parse(JSON.stringify(me.webTemp));
      for (let i = 0; i < me.webRes.length; i++) {
        if (me.webRes[i].status === '严重' || me.webRes[i].status2 === '严重') {
          me.webRes[i].status = '严重'
          me.webRes[i].status2 = '严重'
        }else if(me.webRes[i].status === '预警' || me.webRes[i].status2 === '预警'){
          me.webRes[i].status = '预警'
          me.webRes[i].status2 = '预警'
        }
      }
      me.pageInit();
      me.value = true;
      if (this.webShow.length<13) {
        this.value = false
      }else{
        this.value = true;
      }
    },
    getUsersite: function(data) {
      var me = this;
      me.webTemp = data;
      me.webRes = JSON.parse(JSON.stringify(me.webTemp));
      for (let i = 0; i < me.webRes.length; i++) {
        if (me.webRes[i].status === '严重' || me.webRes[i].status2 === '严重') {
          me.webRes[i].status = '严重'
          me.webRes[i].status2 = '严重'
        }else if(me.webRes[i].status === '预警' || me.webRes[i].status2 === '预警'){
          me.webRes[i].status = '预警'
          me.webRes[i].status2 = '预警'
        }
      }
      me.pageInit();
      me.value = true;
      if (this.webShow.length<13) {
        this.value = false
      }else{
        this.value = true;
      }
    },
    oneSiteRes: function(data){
      console.log('data', data)
      this.getUsersite()
    },
    addMeSite: function(data){    
      var me = this;
      me.resetAddSite()
      if (data.ok == 0) {
        me.$message.error(data.data);
        return;
      }
      me.$store.state.userSite = data.data;
      me.$message({
          message: '站点已添加！',
          type: 'success'
        });
      me.$socket.emit('oneSiteRes', data.address)
      me.getUsersite()
    },

  },
  methods: {
    queryUsageRate(){
      var me=this;
      axios.get(process.env.baseURL+'queryServers')
      .then(res=>{
        me.servers=res.data.data;
      })
    },
    getLike(item) {
      if (!this.adds) {
        if (this.$store.state.likeweb) {
          return this.$store.state.likeweb.indexOf(item.id) == -1
            ? unlikeImg
            : likeImg;
        } else if (!this.$store.state.likeweb) {
          return unlikeImg;
        }
      }else {
        if (this.$store.state.userSite) {
          return this.$store.state.userSite.indexOf(item.id) == -1
            ? unlikeImg
            : likeImg;
        } else if (!this.$store.state.userSite) {
          return unlikeImg;
        }
      }
      
    },
    likes(index, evt){
      if(!this.ifLogin){
        this.$router.push('/')
      }
      else{
        // console.log(this.$store.state.likeweb)
        if (!this.adds) {
          if(this.$store.state.likeweb.indexOf(this.resInfo[index].id) == -1){
            this.$store.commit('addlikeWeb',this.resInfo[index].id)
            this.$socket.emit('changeLike',{
              likeweb:this.$store.state.likeweb,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
          }
          else{
            this.$store.commit('deletelikeWeb',this.resInfo[index].id)
            this.$socket.emit('changeLike',{
              likeweb:this.$store.state.likeweb,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
          }
        } else {
          if(this.$store.state.userSite.indexOf(this.resInfo[index].id) == -1){
            this.$store.commit('adduserSite',this.resInfo[index].id)
            this.$socket.emit('changeUserLike',{
              userSite:this.$store.state.userSite,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
          }
          else{
            this.$store.commit('deleteuserSite',this.resInfo[index].id)
            this.$socket.emit('changeUserLike',{
              userSite:this.$store.state.userSite,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
          }
        }
      }
    },
    staffnames() {
      this.$socket.emit("nameStaff", {
        userName: this.$store.state.userName
      });
    },
    getShowTime() {
      var me = this;
      var nowTime = new Date();
      var year = nowTime.getFullYear();
      var month = nowTime.getMonth() + 1;
      var date = nowTime.getDate();
      var hour = nowTime.toLocaleTimeString();
      me.showTime = year + "-" + month + "-" + date + " " + hour;
    },
    getSite() {
      var me = this;
      me.$socket.emit("getSite");
    },
    getUsersite() {
      var me = this;
      console.log('me.$sotre.state.userSite :>> ', me.$store.state.userSite);
      me.$socket.emit('getUsersite',{
        likeweb:me.$store.state.userSite
      })
    },
    pageInit() {
      var me = this;
      me.webShow = [];
      if (me.showStatus === "全部") {
        me.webShow = JSON.parse(JSON.stringify(me.webRes));
      } else if (me.showStatus === "正常") {
        for (var i in me.webRes) {
          if (
            me.webRes[i].status === "正常" ||
            me.webRes[i].status2 === "正常"
          ) {
            me.webShow.push(me.webRes[i]);
          }
        }
      } else if (me.showStatus === "预警") {
        for (var i in me.webRes) {
          if (
            me.webRes[i].status === "预警" ||
            me.webRes[i].status2 === "预警"
          ) {
            me.webShow.push(me.webRes[i]);
          }
        }
      } else if (me.showStatus === "严重") {
        for (var i in me.webRes) {
          if (
            me.webRes[i].status === "严重" ||
            me.webRes[i].status2 === "严重"
          ) {
            me.webShow.push(me.webRes[i]);
          }
        }
      }
      me.resInfo = me.webShow.slice(
        (me.pageNum - 1) * me.pageCount,
        me.pageNum * me.pageCount
      );
      me.pageTotal = Math.ceil(me.webShow.length / me.pageCount);
      me.siteSuccess = me.siteWarning = me.siteError = 0;
      for (var i in me.webRes) {
        me.webRes[i].status === "严重"
          ? (me.siteError += 1)
          : me.webRes[i].status === "预警"
          ? (me.siteWarning += 1)
          : (me.siteSuccess += 1);
      }
      if (!me.siteWarning) {
        me.siteWarning = "为空";
      }
    },
    pageAutoChange() {
      var me = this;
      me.pageNum === me.pageTotal ? (me.pageNum = 1) : (me.pageNum += 1);
      me.pageInit();
    },
    handleCurrentChange(val) {
      var me = this;
      clearInterval(me.siteChange)
      me.pageNum = val;
      me.pageInit();
      me.siteChange = setInterval(me.pageAutoChange, 10 * 1000);
    },
    searchSite(e) {
      var me = this;
      me.webRes = [];
      for (var item of me.webTemp) {
        if (
          item.name.indexOf(me.searchValue) !== -1 ||
          item.address.indexOf(me.searchValue) !== -1
        ) {
          me.webRes.push(item);
        } else if (
          item.address2 &&
          item.address2.indexOf(me.searchValue) !== -1
        ) {
          me.webRes.push(item);
        }
      }
      me.pageNum = 1;
      me.pageInit();
    },
    clearSearch(e) {
      var me = this;
      me.webRes = JSON.parse(JSON.stringify(me.webTemp));
      me.pageInit();
    },
    getUserdata() {
      this.$socket.emit("socket", "data");
    },
    chartError(dom, num, color, nums) {
      var me = this;
      if (dom ===undefined){
        return
      }
      var chartStatus = echarts.init(dom);
      if (num === nums) {
        num = 0;
      }
      var data = [
        {
          value: num,
          name: "01",
          itemStyle: {
            normal: {
              color: color
            }
          }
        },
        {
          name: "02",
          value: nums - num
        }
      ];
      var option = {
        color: "#303b4a",
        legend: {
          show: false
        },
        series: [
          {
            name: "Line 1",
            type: "pie",
            clockWise: true,
            radius: ["65%", "90%"],
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: data
          }
        ]
      };
      chartStatus.setOption(option);
    },
    chartAlls(dom, num1, num2, num3) {
      var me = this;
      var chartStatus = echarts.init(dom);
      var data = [
        {
          value: num1,
          name: "01",
          itemStyle: {
            normal: {
              color: "#67C23A"
            }
          }
        },
        {
          name: "02",
          value: num2,
          itemStyle: {
            normal: {
              color: "#E6A23C"
            }
          }
        },
        {
          name: "03",
          value: num3,
          itemStyle: {
            normal: {
              color: "#F56C6C"
            }
          }
        }
      ];
      var option = {
        color: "#303b4a",
        legend: {
          show: false
        },
        series: [
          {
            name: "Line 1",
            type: "pie",
            clockWise: true,
            radius: ["65%", "90%"],
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: data
          }
        ]
      };
      chartStatus.setOption(option);
    },
    siteOneShow(index,evt) {
      var me = this;
      clearInterval(me.siteChange)
      if (evt.currentTarget.previousElementSibling) {
        let siteOne = document.getElementsByClassName("siteOne")[index];
        let siteTwo = document.getElementsByClassName("siteTwo")[index];
        siteOne.style.top = "0";
        siteOne.style.opacity = "1";
        siteTwo.style.top = "100%";
        siteTwo.style.opacity = "0";
        evt.toElement.style.backgroundColor = "#222a36";
        evt.currentTarget.previousElementSibling.style.backgroundColor  = "transparent";
      }
      me.siteChange = setInterval(me.pageAutoChange, 10 * 1000);
    },
    siteTwoShow(index,evt) {
      var me = this;
      clearInterval(me.siteChange)
      if (evt.currentTarget.nextElementSibling) {
        let siteOne = document.getElementsByClassName("siteOne")[index];
        let siteTwo = document.getElementsByClassName("siteTwo")[index];
        siteOne.style.top = "-80%";
        siteOne.style.opacity = "0";
        siteTwo.style.top = "0";
        siteTwo.style.opacity = "1";
        evt.currentTarget.nextElementSibling.style.backgroundColor  = "transparent";
        evt.toElement.style.backgroundColor = "#222a36";
      }
      
      me.siteChange = setInterval(me.pageAutoChange, 10 * 1000);
    },
    statusTab(index) {
      clearInterval(this.siteChange)
      function removeByValue(arr, val) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == val) {
            arr.splice(i, 1);
            break;
          }
        }
      }
      let box = [0, 1, 2, 3];
      let text = document.getElementsByClassName("activeTab")[index].innerText;
      document.getElementsByClassName("activeTab")[index].style.color =
        "#21a2f5";
      this.showStatus = text;
      this.pageNum = 1;
      this.pageInit();
      removeByValue(box, index);
      for (let i = 0; i < box.length; i++) {
        document.getElementsByClassName("activeTab")[box[i]].style.color =
          "#ffffff";
      }
      if (this.webShow.length<13) {
        this.value = false
      }else{
        this.value = true;
      }
      this.dataLength = false;
      if (this.webShow.length === 0) {
        this.dataLength = true;
      }
      this.siteChange = setInterval(this.pageAutoChange, 10 * 1000);
    },
    nxsite: function() {
      clearInterval(this.siteChange)
      document.getElementsByClassName("nxsite")[0].style.color = '#21a2f5';
      document.getElementsByClassName("mesite")[0].style.color = '#ffffff';
      this.getSite();
      this.pageNum = 1;
      this.adds = false;
      this.siteChange = setInterval(this.pageAutoChange, 10 * 1000);
    },
    mesite: function() {
      clearInterval(this.siteChange)
      document.getElementsByClassName("mesite")[0].style.color = '#21a2f5';
      document.getElementsByClassName("nxsite")[0].style.color = '#ffffff';
      this.getUsersite();
      this.pageNum = 1;
      this.adds = true;
      this.siteChange = setInterval(this.pageAutoChange, 10 * 1000);
    },
    addSiteShow(){
      this.actPro = !this.actPro;
    },
    resetAddSite() {
      var me = this
      me.addSite = {
        name:null,
        address:null,
      }
      me.actPro = false
    },
    addMesite() {
      var me = this
      if (me.addSite.name && me.addSite.address) {
        if (me.IsURL(me.addSite.address)) {
          me.$socket.emit('addMeSite', {
            userName: me.$store.state.userName,
            userApple: me.$store.state.userApple,
            unionid: me.$store.state.wxAppData,
            name: me.addSite.name,
            address: me.addSite.address,
            userSite: me.$store.state.userSite
          })
        }else{
          me.$message.error('请输入正确的网站地址');
          me.resetAddSite()
        }
      }else{
        me.$message({
          message: '网站名称或网站地址不能为空',
          type: 'warning'
        });
        me.resetAddSite()
      }
    },
    IsURL(str_url){
      var strRegex = "^((https|http|ftp|rtsp|mms)?://)"
      + "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@ 
        + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184 
        + "|" // 允许IP和DOMAIN（域名）
        + "([0-9a-z_!~*'()-]+\.)*" // 域名- www. 
        + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名 
        + "[a-z]{2,6})" // first level domain- .com or .museum 
        + "(:[0-9]{1,4})?" // 端口- :80 
        + "((/?)|" // a slash isn't required if there is no file name 
        + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$"; 
        var re=new RegExp(strRegex); 
      //re.test()
        if (re.test(str_url)){
        return (true); 
        }else{ 
        return (false); 
        }
    }
  },
  watch: {
    siteError: function() {
      var me = this;
      me.$nextTick(function() {
        //初始化echarts
        if (me.siteWarning === "为空") {
          me.siteWarning = 0;
        }
        setTimeout(function(){
          if (me.$refs.chartError) {
            me.chartError(
              me.$refs.chartError,
              me.siteError,
              "#F56C6C",
              me.siteError + me.siteWarning + me.siteSuccess
            );
          }else{
          }
        },500)
      });
    },
    siteWarning: function() {
      var me = this;
      me.$nextTick(function() {
        //初始化echarts
        if (me.siteWarning === "为空") {
          me.siteWarning = 0;
        }
        setTimeout(function(){
        if (me.$refs.chartWarning) {
          me.chartError(
            me.$refs.chartWarning,
            me.siteWarning,
            "#E6A23C",
            me.siteError + me.siteWarning + me.siteSuccess
          );
        }
        },500)
      });
    },
    siteSuccess: function() {
      var me = this;
      me.$nextTick(function() {
        //初始化echarts
        if (me.siteWarning === "为空") {
          me.siteWarning = 0;
        }
        setTimeout(function(){
          if (me.$refs.chartSuccess) {
            me.chartError(
              me.$refs.chartSuccess,
              me.siteSuccess,
              "#67C23A",
              me.siteError + me.siteWarning + me.siteSuccess
            );
          }
          if (me.$refs.chartAll) {
            me.chartAlls(
              me.$refs.chartAll,
              me.siteSuccess,
              me.siteWarning,
              me.siteError
            );
          }
         },500)
      });
    }
  },
  computed: {
    dropdownColor() {
      var me = this;
      if (me.showStatus === "全部") {
        return "#409eff";
      } else if (me.showStatus === "正常") {
        return "#67c23a";
      } else if (me.showStatus === "预警") {
        return "#e6a23c";
      } else {
        return "#f56c6c";
      }
    },
    ifLogin() {
      return this.$store.state.ifLogin;
    },
    nickName() {
      return this.$store.state.nickName;
    },
    likeweb() {
      return this.$store.state.likeweb;
    },
  }
};
</script>

<style lang="less" scoped>
.business {
  position: relative;
  padding-bottom: 20px;
  .editPro{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    .editBox{
      z-index: 1000;
      position: absolute;
      width: 50%;
      // height: 370px;
      left: 0;
      right: 0;
      margin: 0 auto;
      margin-top: 60px;
      border-radius: 3%;
      color: #fff;
      font-size: 16px;
      text-align: left;
      overflow: hidden;
      .editTitle{
        text-align: center;
        padding: 5px 0;
      }
      .editContent{
        padding: 15px 20px;
        div{
          padding: 3px 0;
          span{
            display: inline-block;
          }
          span:first-child{
            width: 180px;
          }
        }
        .editBtn{
          padding-top: 20px;
          text-align: right;
          span{
            width: 100px;
            text-align: right;
            button{
              width: 60px;
              height: 30px;
              padding: 8px 10px;
              color: #fff;
              background: #222a36;
              border: 0;
              box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2),0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 3px rgba(0, 0, 0, 0.12) !important;
            }
            button:hover{
              color: #21a2f5;
            }
          }
          span:first-child{
            width: 100px;
            margin-right: 30px;
          }
        }
        .otherTime{
          margin-top: 5px;
        }
        .el-button{
          padding: 3px;
        }
      }
    }
  }
  .editData{
    z-index: 9999;
    height: 100%;
    transition: all 1s;
  }
  .noData{
    width: 100%;
    margin: 0 auto;
    position: absolute;
    bottom: 43%;
    text-align: center;
    div{
      font-size: 18px;
      color:#ccc;
      margin-top: 2%;
      a{
        padding-left: 3px;
        color: cornflowerblue;
      }
    }
    img{
      width: 200px;
      height: 200px;
    }
    .noText{
       margin-top: 0%;
    }
  }
  .info-wrap {
    // min-height: 800px;
    // display: flex;
    // top: 0;
    // left: 0;
    // flex-direction: column;
    // align-items: center;
    margin-bottom: 50px;
    padding-top: 50px;
    .loading{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      background-color: #181e26;
      .loadingImg{
        width: 320px;
        height: 240px;
        background-image: url(../../assets/loading.gif);
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 420px;
        color: #21a2f5;
        font-size: 18px;
      }
    }
    .web-table {
      width: 90vw;
      min-height: 600px;
      margin: 0 auto;
      padding-top: 3vh;
      .tableBox {
        width: 23.8%;
        height: 175px;
        display: inline-block;
        margin: 0 1vw 2vh 0;
      }
      .tableItem {
        width: 100%;
        height: 100%;
        color: #fff;
        background-color: rgba(117, 176, 243, 0.2);
        background-color: #313a46;
        border-radius: 7px;
        padding: 10px 0.5vw;
        line-height: 14px;
        text-align: left;
        font-size: 14px;
        position: relative;
        overflow: hidden;
        .tableName {
          text-align: left;
          width: 80%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .line {
          width: 80%;
          height: 2px;
          background: rgb(24, 30, 38, 0.4);
          position: absolute;
          top: 32px;
          left: 0;
        }
        .siteBox {
          width: 100%;
          height: 80%;
          overflow: hidden;
          position: relative;
          top: 5%;
          .siteOne {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            transition: all 0.5s;
          }
          .siteTwo {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 100%;
            transition: all 0.5s;
          }
          .address {
            margin-top: 10px;
            font-size: 12px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .speed {
            margin-top: 5px;
            font-size: 12px;
            .second {
              font-size: 12px;
            }
          }
          .pv {
            margin-top: 5px;
            font-size: 12px;
            span {
              padding-right: 15%;
            }
          }
          .cpu {
            margin-top: 8px;
            font-size: 12px;
            .lineLeft {
              display: inline-block;
              float: left;
            }
            .lineBox {
              width: 35%;
              height: 12px;
              border: 1px solid rgb(146, 146, 148);
              display: inline-block;
              background: #181e26;
              line-height: 10px;
              box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
                0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
              position: relative;
            }
            .lineItem {
              position: absolute;
              width: 0%;
              height: 100%;
              top: 0%;
              z-index: 99;
              overflow: hidden;
            }
            .boxItem {
              width: 7.6vw;
              height: 100%;
              background: linear-gradient( to right, #21a2f5, #fafb0d, #F56C6C);
            }
            .wLine {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0%;
              z-index: 99;
              span {
                width: 17.5%;
                height: 100%;
                border-right: 1px solid rgb(148, 146, 146);
                display: inline-block;
              }
            }
            .lineText {
              padding-left: 5px;
            }
          }
        }
        .tableBtn {
          position: absolute;
          bottom: 5%;
          right: 5%;
          width: 100%;
          font-size: 12px;
          z-index: 99;
          div {
            border: 1px solid rgb(148, 146, 146);
            padding: 2px 5px;
            border-radius: 10px;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
              0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
            float: right;
            display: inline-block;
            margin-left: 8%;
            cursor: pointer;
          }
          .siteBtnOne {
            background: #222a36;
          }
        }
        .tableLike {
          position: absolute;
          top: 4px;
          right: 5%;
          img {
            width: 25px;
            cursor: pointer;
          }
        }
        .addImg{
          width: 60%;
          height: 80%;
          cursor: pointer;
          img{
            width: 60%;
          }
        }
      }
      .zhengchang {
        background: linear-gradient(
          to top right,
          #313a46 20%,
          #444e58 80%
        ); //正常
      }
      .yujing {
        background: linear-gradient(
          to top right,
          rgb(160, 116, 49) 20%,
          rgba(146, 116, 71, 0.6) 80%
        ); //严重
      }
      .yanzhong {
        background: linear-gradient(
          to top right,
          #965252 20%,
          #5c3938 80%
        ); //严重
      }
    }
    .info-search {
      width: 90vw;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #c7dfea;
      font-size: 2rem;
      margin-top: 3vh;
      span {
        display: inline-block;
        width: 10vw;
      }
      .el-input {
        display: inline-block;
        padding: 0;
        margin: 0;
        width: 15vw;
      }
    }
    .info-top {
      color: #fff;
      display: flex;
      width: 90vw;
      height: 110px;
      margin: 0 auto;
      justify-content: space-between;
      .info-dropdown {
        width: 30vw;
        height: 100%;
        margin-top: 1vh;
        align-self: center;
        line-height: 40px;
        // background: #222a36;
        text-align: left;
        span {
          display: inline-block;
          padding-right: 5%;
        }
        .el-input {
          display: inline-block;
          width: 28vw;
          height: 40px;
        }
      }
      .switchSite {
        width: 28vw;
        height: 40px;
        margin-top: 6.5%;
        align-self: center;
        line-height: 40px;
        text-align: left;
        font-size: 12px;
        span {
          height: 30px;
          line-height: 25px;
          display: inline-block;
          cursor: pointer;
          border: 1px solid rgb(148, 146, 146);
          padding: 2px 5px;
          margin-right: 5%;
          border-radius: 10px;
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
            0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
        }
        .insite{
          color: rgb(33, 162, 245);
        }
      }
      .info-top-title {
        color: #c7dfea;
        font-size: 2.5rem;
        text-align: left;
        height: 3vh;
        margin: 2vh 1vw;
        font-weight: 350;
        align-self: center;
      }
      .info-status {
        display: flex;
        width: 30vw;
        justify-content: space-around;
        font-size: 2vh;

        .info-status-list {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          position: relative;
          .chartStatusBox {
            width: 100%;
            height: 100%;
            // box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
          }
          .chartNum {
            width: 100%;
            font-weight: 600;
            position: absolute;
            top: 27px;
            z-index: 99;
          }
          .info-error {
            color: #f56c6c;
          }
          .info-warning {
            color: #e6a23c;
          }
          .info-success {
            color: #67c23a;
          }
          .info-all {
            color: #ccc;
          }
          .activeTab {
            cursor: pointer;
            margin: 5px 10%;
            font-size: 14px;
          }
        }
      }
    }
    .info-page {
      margin-top: 2vh;
    }
  }
  .ysxy {
    color: #fff;
    font-size: 14px;
    text-decoration: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pc/PCWeb.vue